import React, {useState} from 'react'
import './todos.less'
import {
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import {instance as toDoService} from '../../services/ToDoService'
import {useIntl} from 'react-intl'
import {Button, Popconfirm, Radio} from 'antd'
import {ToDoTypeInput} from './ToDoTypeInput'
import {ToDoTypeEditButton} from './ToDoTypeEditButton'
import {useSubmit} from 'react-router-dom'
import {CustomToDoType, CustomType} from '../../entities/journalRecord'
import {PostgrestError} from '@supabase/supabase-js'
import data from '@emoji-mart/data'
import {init} from 'emoji-mart'
import {EmEmoji} from '../emoji/EmEmoji'

export type ToDoCustomTypeRadioButtonProps = {
  customToDoType: CustomType
  editableTypeId: number | null
  setEditableTypeId: (id: number | null) => void
  onChangeUserType: (editedType: CustomType) => Promise<
    | {
        success: true
        data: CustomType
      }
    | {
        success: false
        error: PostgrestError
      }
  >
  onDeleteUserType: (editedTypeId: number) => void
}

export function ToDoCustomTypeRadioButton(props: ToDoCustomTypeRadioButtonProps) {
  const intl = useIntl()
  const [changedUserType, setChangedUserType] = useState(props.customToDoType)
  const submit = useSubmit()

  if (props.customToDoType.id === props.editableTypeId) {
    return (
      <span>
        <ToDoTypeInput userType={changedUserType} setUserType={setChangedUserType} />
        <Button
          type="link"
          onClick={async () => {
            const result = await toDoService.editUserToDoType(props.customToDoType)
            if (result.success) {
              props.setEditableTypeId(null)
              props.onChangeUserType(result.data)
              submit(result.data.id ? {id: String(result.data.id)} : null, {method: 'post'})
            }
          }}
        >
          <CheckOutlined />
        </Button>
      </span>
    )
  }

  return (
    <Radio value={props.customToDoType}>
      <span style={{display: 'flex', flexWrap: 'nowrap', alignItems: 'center'}}>
        <span style={{flexGrow: 1, wordBreak: 'break-word'}}>
          <EmEmoji id={props.customToDoType.icon} size="1em"></EmEmoji>

          {props.customToDoType.name}
        </span>

        <span
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            width: 'min-content',
            alignItems: 'center',
          }}
        >
          <ToDoTypeEditButton userType={props.customToDoType} onEditType={props.onChangeUserType} />

          <Popconfirm
            placement="bottom"
            title={intl.formatMessage({id: 'areYouSureYouWantToDelete'})}
            description={intl.formatMessage({id: 'thisOperationIsIrreversible'})}
            icon={<QuestionCircleOutlined style={{color: 'red'}} />}
            onConfirm={(e) => props.onDeleteUserType(props.customToDoType.id)}
            okText={intl.formatMessage({id: 'yes'})}
            cancelText={intl.formatMessage({id: 'no'})}
          >
            <Button type="link" icon={<DeleteOutlined />} />
          </Popconfirm>
        </span>
      </span>
    </Radio>
  )
}
